import { Injectable } from '@angular/core';
import {isNext, salesChannel} from '../../core/utils/utils';
import {NextBannersConfig, NextBannerConfig, NextStepBannerConfig} from '../../core/models/next-banners-config';
import {NEXT_BANNERS_CONFIG} from '../../core/configs/next-banners-config';
import {StepBannerConfig} from '../../core/models/banners-partner-config';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {ApplicationContextService} from '../../core/services/impl/configuration/application-context.service';

@Injectable({
  providedIn: 'root'
})
export class NextBannersService {

  isNext = isNext();
  private config: NextBannersConfig;

  constructor(private contextService: ApplicationContextService) {
    this.initConfig();
  }

  isBannerEnabledOnStep(stepKey: string): boolean {
    if (isNotNullOrUndefined(this.config)) {
      const stepBannerConfig = this.getStepBannerConfig(stepKey);
      return stepBannerConfig ? !stepBannerConfig.disabled : false;
    }
    return false;
  }

  getStepBannerConfig(stepKey: string): NextBannerConfig {
    const contextBanner = this.contextService.getStepCustomBanner(stepKey);
    if (contextBanner) {
      return contextBanner;
    }
    const stepConfig = this.config.bannerSteps.find(config => config.stepKey === stepKey);
    return stepConfig ? stepConfig.banner : null;
  }

  private initConfig(): void {
    this.config = NEXT_BANNERS_CONFIG.find(config => config.salesChannel === salesChannel());
  }
}
